import { Service } from '@roc/feature-app-core';

export class WireInstructionsService extends Service {
  getWireInstructionsData(encodedParam: string) {
    return this.get('/api/v1/vendor/public/wire/getData', { param: encodedParam });
  }

  submitWireInstructions(formData: FormData) {
    return this.post('/api/v1/vendor/public/wire/submit', formData);
  }
}
